import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "imagecanvas" }
const _hoisted_2 = { class: "image-title" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]

import {ref, onMounted} from 'vue';
import { Modal } from "flowbite-vue";
import { initFlowbite } from "flowbite";


export default /*#__PURE__*/_defineComponent({
  __name: 'taccuinoView',
  emits: ["cancel"],
  setup(__props, { expose: __expose, emit }) {

const showConfirm = ref(false);
const imageDataBackUrl = ref('');
const imageDataUrl = ref('');
let resolvePromise: (value: PromiseLike<boolean> | boolean) => void;



onMounted(() => {
  initFlowbite();
});

function openModal(message: string, imageurl: string, backurl: string): Promise<boolean> {

imageDataBackUrl.value = backurl;
imageDataUrl.value = imageurl;
showConfirm.value = true;
return new Promise((resolve) => {
  resolvePromise = resolve;
});

}

function closeModal() {
  showConfirm.value = false
  if (!resolvePromise) return;
         resolvePromise(false);
  emit("cancel");
  
}

__expose({ openModal });

return (_ctx: any,_cache: any) => {
  return (showConfirm.value === true)
    ? (_openBlock(), _createBlock(_unref(Modal), {
        key: 0,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (showConfirm.value = false))
      }, {
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("Immagine di anteprima")), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: imageDataUrl.value,
                alt: "Test",
                style: {"width":"30%"}
              }, null, 8, _hoisted_3),
              _createElementVNode("img", {
                src: imageDataBackUrl.value,
                alt: "Test",
                style: {"width":"30%"}
              }, null, 8, _hoisted_4)
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})